export default __webpack_public_path__ + "static/media/iconCopy.b966bd1e.svg";